import React from 'react';

import FlowchartNodeToolbar, {
  FlowchartNodeToolbarButton,
} from 'ui-library/reactflow/nodes/toolbar/FlowchartNodeToolbar';

export interface ProcessFlowchartNodeToolbarProps {
  isLocked?: boolean;
  onNodeEdit?: () => void;
  onNodeDuplicate?: () => void;
  onNodeDelete?: () => void;
  /**
   * When provided, the delete button is rendered as disabled with this string shown in a tooltip
   * on hover. Use this to communicate why a node can't be deleted (e.g., tasks already exist).
   * Has no effect when {@link onNodeDelete} is not provided.
   */
  deleteDisabledTooltip?: string;
}

export default function ProcessFlowchartNodeToolbar({
  isLocked,
  onNodeEdit,
  onNodeDuplicate,
  onNodeDelete,
  deleteDisabledTooltip,
}: ProcessFlowchartNodeToolbarProps): JSX.Element | null {
  if (!onNodeEdit && !onNodeDelete && !onNodeDuplicate) {
    return null;
  }

  const buttons: Array<FlowchartNodeToolbarButton> = [];

  if (onNodeEdit) {
    buttons.push({
      icon: isLocked ? 'eye' : 'edit', // When locked, the sidepanel should still open but in read only mode
      onClick: onNodeEdit,
      elementName: 'editNodeButton',
      ariaLabel: 'Edit node',
    });
  }
  if (onNodeDuplicate) {
    buttons.push({
      icon: 'copy',
      onClick: onNodeDuplicate,
      elementName: 'duplicateNodeButton',
      ariaLabel: 'Duplicate node',
    });
  }
  if (onNodeDelete) {
    buttons.push({
      icon: 'trash-can',
      onClick: onNodeDelete,
      elementName: 'deleteNodeButton',
      disabled: deleteDisabledTooltip != null,
      tooltip: deleteDisabledTooltip,
      ariaLabel: 'Delete node',
    });
  }
  return <FlowchartNodeToolbar buttons={buttons} />;
}
